export default [
  {
    key: 'date',
    name: '日期',
    fixed: true,
    summaryWidth: 180,
    detailWidth: 130
  },
  {
    key: 'media_type',
    name: '媒体类型',
    fixed: true
  },
  {
    key: 'adslot_type',
    name: '资源位类型',
    fixed: true
  },
  {
    key: 'sale_type',
    name: '销售团队',
    fixed: true
  },
  {
    key: 'category_one',
    name: '一级行业',
    fixed: true
  },
  {
    key: 'category_two',
    name: '二级行业',
    fixed: true
  },
  {
    key: 'category_three',
    name: '三级行业',
    fixed: true
  }
];
